<template>
  <fragment>
    <c-generic-section top-divider>
      <div class="container-xs">
        <h2 class="mt-0">Contact Dima for a free consultation call about your client's B2B Web App</h2>

        <div class="contact-box">
          <ul>
            <li>
              Email:
              <a href="mailto:dima@MVPforSaaS.com">dima@MVPforSaaS.com</a>
            </li>
            <li>
              Phone:
              <a href="tel:+18662338741">1-866-233-8741</a>
            </li>
          </ul>
        </div>
        <template v-if="!showThankYou">
          <form ref="form">
            <fieldset>
              <div class="mb-16">
                <label class="form-label" for="form-name">Your name</label>
                <c-input
                  :extraClasses="[showError ? 'form-error' : null]"
                  name="name"
                  type="text"
                  label="This is a label"
                  placeholder="Full name"
                  label-hidden
                  v-model="form.name"
                ></c-input>
                <c-input name="firstName" type="hidden" :value="firstName" label-hidden></c-input>
                <c-input name="lastName" type="hidden" :value="lastName" label-hidden></c-input>
                <c-input name="country" type="hidden" :value="ipInfo.country" label-hidden></c-input>
                <c-input name="city" type="hidden" :value="ipInfo.city" label-hidden></c-input>
                <c-input name="region" type="hidden" :value="ipInfo.region" label-hidden></c-input>
              </div>
              <div class="mb-16">
                <label class="form-label" for="form-website">Your website</label>
                <c-input
                  :extraClasses="[showError ? 'form-error' : null]"
                  name="url"
                  type="text"
                  label="This is a label"
                  placeholder="https://your-agency.com"
                  label-hidden
                  v-model="form.website"
                ></c-input>
              </div>
              <div class="mb-16">
                <label class="form-label" for="form-email">Your email</label>
                <c-input
                  :extraClasses="[showError ? 'form-error' : null]"
                  name="email"
                  type="email"
                  label="This is a label"
                  placeholder="Your best email"
                  label-hidden
                  v-model="form.email"
                ></c-input>
              </div>
              <div class="mb-16">
                <label class="form-label" for="form-phone">Your phone</label>
                <c-input
                  :extraClasses="[showError ? 'form-error' : null]"
                  name="phone"
                  type="text"
                  label="This is a label"
                  placeholder="Your best phone number"
                  label-hidden
                  v-model="form.phone"
                ></c-input>
              </div>

              <div class="mt-32">
                <c-button
                  color="primary"
                  :disabled="disabled"
                  wide
                  @click.prevent="submitForm"
                >Get A FREE consultation</c-button>
              </div>
            </fieldset>
          </form>
        </template>

        <template v-if="showError">
          <div class="mt-16">
            <div class="msg msg-error">
              Uh oh. Something went wrong during form submission. Could you please email
              <a
                href="mailto:dima@mvpforsaas.com"
              >dima@MvpForSaaS.com</a> instead?
            </div>
          </div>
        </template>

        <template v-if="showThankYou">
          <div class="mt-16">
            <div
              class="msg msg-success"
            >Awesome! Your contact info has been submitted, and I'll ping you right away to schedule our first (free) call.</div>
          </div>
        </template>
      </div>
    </c-generic-section>
  </fragment>
</template>

<script>
import { isValidEmail } from "@/utils/Helpers.js";
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
import CGenericSection from "@/components/sections/GenericSection.vue";
// import CCta from "@/components/sections/Cta.vue";
import CInput from "@/components/elements/Input.vue";
import CButton from "@/components/elements/Button.vue";

export default {
  name: "Secondary",
  components: {
    CGenericSection,
    // CCta,
    CInput,
    CButton
  },
  data() {
    return {
      form: {
        name: null,
        email: null,
        phone: null,
        city: null,
        website: null
      },
      ipInfo: {
        country: null,
        city: null,
        region: null
      },
      showThankYou: false,
      showError: false
    };
  },
  created() {
    this.$emit("update:layout", CLayout);
    this.getIpInfo();
  },
  computed: {
    firstName() {
      if (this.form.name && this.form.name.includes(" "))
        return this.form.name.split(" ")[0];
      else if (this.form.name && this.form.name.length > 2)
        return this.form.name;
      return "";
    },
    lastName() {
      if (this.form.name && this.form.name.includes(" "))
        return this.form.name.split(" ")[1];
      return "";
    },
    emailIsValid() {
      return isValidEmail(this.form.email);
    },
    disabled() {
      return (
        !this.form.name ||
        !this.form.email ||
        !this.form.website ||
        !this.form.phone ||
        !this.emailIsValid
      );
    }
  },
  methods: {
    getIpInfo() {
      fetch("https://extreme-ip-lookup.com/json/")
        .then(res => res.json())
        .then(response => {
          this.ipInfo.country = response.country;
          this.ipInfo.city = response.city;
          this.ipInfo.region = response.region;
        })
        // eslint-disable-next-line no-console
        .catch((data, status) => console.error(data, status));
    },
    isValidEmail: email => isValidEmail(email),
    submitForm() {
      try {
        this.showError = false;
        this.showThankYou = false;

        const xhr = new XMLHttpRequest();
        xhr.open(
          "POST",
          "https://hooks.zapier.com/hooks/catch/2939789/odijr5l/"
        );
        xhr.onload = event => {
          if (event.target.status === 200) {
            this.showThankYou = true;
          }
        };
        // or onerror, onabort
        var formData = new FormData(this.$refs.form);
        xhr.send(formData);
      } catch (err) {
        this.showError = true;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.contact-box {
  background: rgba(0, 0, 0, 0.75);
  padding: 1rem;
  margin-bottom: 1rem;

  ul {
    margin: 0;
  }
}
.msg {
  padding: 1rem;
  border-radius: 5px;
}

.msg-error {
  background: rgb(255, 203, 212);
  color: maroon;
  text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.5);

  a:hover {
    color: rgb(0, 68, 255);
  }
}
.msg-success {
  background: rgba(0, 0, 0, 0.4);
  color: white;
}
</style>